(function () {
  function initOne(swiperEl) {
    if (!swiperEl || !window.Swiper) return null;

    // 避免重复初始化（Shopify 主题编辑器/局部刷新很常见）
    if (swiperEl.dataset.swiperInited === "1") return null;
    swiperEl.dataset.swiperInited = "1";

    const swiper = new Swiper(swiperEl, {
      loop: true,
      centeredSlides: true,
      watchSlidesProgress: true,

      simulateTouch: true,
      allowTouchMove: true,
      grabCursor: true,

      freeMode: {
        enabled: true,
        momentum: false,
        sticky: false,
      },

      speed: 10000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },

      slidesPerView: 6.8,
      spaceBetween: 16,

      breakpoints: {
        0: { slidesPerView: 1.8, spaceBetween: 10, centeredSlides: true },
        550: { slidesPerView: 2, spaceBetween: 10, centeredSlides: true },
        768: { slidesPerView: 2.2, spaceBetween: 12, centeredSlides: true },
        1000: { slidesPerView: 3.2, spaceBetween: 14, centeredSlides: true },
        1200: { slidesPerView: 4.2, spaceBetween: 16, centeredSlides: true },
        1500: { slidesPerView: 5.2, spaceBetween: 16, centeredSlides: true },
        2000: { slidesPerView: 6.8, spaceBetween: 16, centeredSlides: true },
      },

      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: false,
      },
    });

    // hover 立即停/走（绑定到 swiperEl 或外层都行）
    swiperEl.addEventListener("mouseenter", () => swiper.autoplay && swiper.autoplay.stop());
    swiperEl.addEventListener("mouseleave", () => swiper.autoplay && swiper.autoplay.start());

    // 移动端：按住停，松开走（更符合直觉）
    swiperEl.addEventListener(
      "touchstart",
      () => swiper.autoplay && swiper.autoplay.stop(),
      { passive: true }
    );
    swiperEl.addEventListener(
      "touchend",
      () => swiper.autoplay && swiper.autoplay.start(),
      { passive: true }
    );

    return swiper;
  }

  function initAll() {
    if (!window.Swiper) return;

    // ✅ 推荐选择器：找每个模块自己的 swiper
    const swipers = document.querySelectorAll('[data-auto-swiper] [data-swiper]');

    // 如果你还没改 HTML（仍是 id="custom-swiper-b"），用这个兜底：
    const fallback = document.querySelectorAll("#custom-swiper-b");

    const nodes = swipers.length ? swipers : fallback;

    nodes.forEach((el) => initOne(el));
  }

  // Shopify 主题编辑器：区块加载/切换时也能初始化
  document.addEventListener("shopify:section:load", initAll);
  document.addEventListener("shopify:block:select", initAll);

  if ("requestIdleCallback" in window) {
    requestIdleCallback(initAll, { timeout: 3000 });
  } else if (document.readyState === "complete") {
    initAll();
  } else {
    window.addEventListener("load", initAll, { once: true });
  }
})();
